import { render, staticRenderFns } from "./Ulker.vue?vue&type=template&id=5b808785&"
import script from "./Ulker.vue?vue&type=script&lang=js&"
export * from "./Ulker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports